import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePickerInput.css";
import { Calendar } from "lucide-react";
import { Input } from "@/components/ui/input";

const DatePickerInput = ({ id, value, onChange, className = "", "data-testid": dataTestId }) => {
  // Convert string value to Date object
  const dateValue = value ? new Date(value) : null;

  const handleDateChange = (date) => {
    if (date) {
      // Convert Date to YYYY-MM-DD format using local timezone (not UTC)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      // Simulate event object for compatibility with existing onChange handlers
      onChange({ target: { value: formattedDate } });
    } else {
      onChange({ target: { value: "" } });
    }
  };

  return (
    <div className="relative">
      <DatePicker
        id={id}
        selected={dateValue}
        onChange={handleDateChange}
        dateFormat="dd/MM/yyyy"
        placeholderText="Pilih tanggal"
        customInput={
          <Input
            className={`pr-10 ${className}`}
            data-testid={dataTestId}
          />
        }
        showPopperArrow={false}
        popperClassName="date-picker-popper"
        popperPlacement="bottom-start"
        portalId="root"
      />
      <div className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
        <Calendar size={20} />
      </div>
    </div>
  );
};

export default DatePickerInput;
